// Purpose: Verify JWT exists and is structurally valid — redirects to / if missing/invalid
// Caller: AuthenticatedNavbar
// Dependencies: jsonwebtoken
// Main Functions: verifyToken
// Side Effects: Redirects to / on missing or invalid token

import history from 'utils/history'
import jwt from 'jsonwebtoken'

const isValidToken = (decoded) => {
  if (!decoded || typeof decoded !== 'object') return false
  if (!decoded.user) return false
  if (decoded.exp && decoded.exp < Date.now() / 1000) return false
  return true
}

export const verifyToken = () => {
  try {
    const accessToken = localStorage.getItem('accessToken')
    if (!accessToken) {
      history.push('/')
      return {}
    }

    const parts = accessToken.split('.')
    if (parts.length !== 3) {
      localStorage.removeItem('accessToken')
      history.push('/')
      return {}
    }

    const decoded = jwt.decode(accessToken)
    if (!isValidToken(decoded)) {
      localStorage.removeItem('accessToken')
      history.push('/')
      return {}
    }

    return decoded.user
  } catch {
    localStorage.removeItem('accessToken')
    history.push('/')
    return {}
  }
}
